import { createApp } from 'vue';
import PersonBubble from './vue/person-bubble.vue';
import { context } from './person-bubble.config.yml';


const app = createApp(PersonBubble, context);
app.mount('#person-bubble-root');
